import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import i18n from '../i18n';

Vue.use(VueRouter);

const supportedLanguages = ['en', 'sv'];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes
});

router.beforeEach((to, from, next) => {
  const supportedLanguages = ['en', 'sv', 'fi'];
  const urlLang = to.params.lang;
  const storedLang = localStorage.getItem('lang');
  const fallbackLang = supportedLanguages.includes(storedLang) ? storedLang : 'sv';


  if (storedLang && supportedLanguages.includes(storedLang) && urlLang !== storedLang) {
    const pathWithoutLang = to.fullPath.replace(/^\/(en|sv)/, '');
    const redirectPath = `/${storedLang}${pathWithoutLang}`;

    if (to.fullPath !== redirectPath) {
      return next(redirectPath); 
    }
  }

  if (supportedLanguages.includes(urlLang)) {
    if (i18n.locale !== urlLang) {
      i18n.locale = urlLang;
      localStorage.setItem('lang', urlLang);
    }
    return next(); 
  }

  const pathWithoutLang = to.fullPath.replace(/^\/(en|sv|fi)/, '');
  const redirectPath = `/${fallbackLang}${pathWithoutLang}`;

  if (to.fullPath !== redirectPath) {
    return next(redirectPath); 
  }

  return next(); 
});



export default router;
